// The portal's page beacon (docs/app-concept.md §11): each page a signed-in
// brand opens, as its route pattern and never an id, goes to
// POST /api/brand/analytics, and the Worker sends it on to our analytics
// under the company (surfaces/brand/analytics.ts). No analytics script,
// cookie or key in the browser.

import {useEffect, useRef} from 'react';
import {matchPath, useLocation} from 'react-router-dom';
import {useBrand} from './store';

/** The routes of App.tsx, the fixed ones before the one with an id they would also match. */
const PAGES = ['/', '/company', '/agreement', '/plan', '/billing', '/team', '/campaigns', '/campaigns/new',
  '/campaigns/:id/edit', '/campaigns/:id', '/reviews', '/analytics', '/api'];
const CAMPAIGN_TABS = ['applicants', 'invite', 'creators', 'results'];
/** A redirect passes through a page in a moment (setup sends every other page to its step): only a page that stays counts. */
const SETTLE_MS = 400;

export function BrandAnalytics() {
  const {pathname, search} = useLocation();
  const {status} = useBrand();
  const last = useRef('');

  useEffect(() => {
    if (status !== 'ready') { last.current = ''; return undefined; }
    const page = PAGES.find((pattern) => matchPath(pattern, pathname));
    if (!page) return undefined;
    const tab = page === '/campaigns/:id' ? new URLSearchParams(search).get('tab') : null;
    const view = JSON.stringify({page, ...(tab && CAMPAIGN_TABS.includes(tab) ? {tab} : {})});
    if (view === last.current) return undefined;
    const timer = window.setTimeout(() => {
      last.current = view;
      void fetch('/api/brand/analytics', {method: 'POST', headers: {'content-type': 'application/json'}, body: view})
        .catch(() => undefined);
    }, SETTLE_MS);
    return () => window.clearTimeout(timer);
  }, [pathname, search, status]);

  return null;
}
